module.exports = __webpack_public_path__ + "static/media/track-BG-5th-layer-five@2x.52a6132c.png";